import classNames from 'classnames'
import { Sidebar } from '../../components/sidebar/sidebar'
import { SidebarProvider, useSidebar } from '../../context/sidebar.context'
import classes from './main-layout.module.scss'
import { DisplayTimezoneProvider } from 'src/modules/core/context'
import { IntercomChat } from 'src/modules/intercom'
import { InboundNotificationsProvider } from 'src/modules/inbound-notifications/context/inbound-notifications-context'

export function MainLayout({ children }) {
  return (
    <SidebarProvider>
      <DisplayTimezoneProvider>
        <InboundNotificationsProvider>
          <IntercomChat />
          <div className={classes.root}>
            <Sidebar />
            <MainLayoutContent>{children}</MainLayoutContent>
          </div>
        </InboundNotificationsProvider>
      </DisplayTimezoneProvider>
    </SidebarProvider>
  )
}

function MainLayoutContent({ children }) {
  const { isCollapsed } = useSidebar()
  return <div className={classNames(classes.content, { [classes.contentExpanded]: isCollapsed })}>{children}</div>
}
